/* This hook returns returns two functions:
	setIntervalWebWorker and clearIntervalWebWorker, which are
	similar to the window API functions setInterval and
	clearInterval respectively, but differ as follows:
	(1) setIntervalWebWorker does not get throttled when
	the tab or window is closed.
	(2) setIntervalWebWorker does not return a handle, nor does
	clearIntervalWebWorker accept one, so a single call to useIntervalWebWorker
	is required to manage at most one timer instance.
 */
export default function useIntervalWebWorker() {
  let worker = null;
  const constants = {
    SET_INTERVAL: 'setInterval',
    CLEAR_INTERVAL: 'clearInterval',
    TICK: 'tick',
  };

  const workerRoutine = () => {
    const SET_INTERVAL = 'setInterval';
    const CLEAR_INTERVAL = 'clearInterval';
    const TICK = 'tick';

    let timerHandle;

    onmessage = (event) => {
      const request = event.data;

      if (typeof request === 'object' && !!request.messageType) {
        switch (request.messageType) {
          case SET_INTERVAL:
            if (timerHandle) {
              clearInterval(timerHandle);
            }
            timerHandle = setInterval(() => {
              postMessage(TICK);
            }, request.intervalMilliseconds);
            break;

          case CLEAR_INTERVAL:
            clearInterval(timerHandle);
            break;
        }
      }
    };
  };

  const getWorker = () => {
    const code = workerRoutine.toString();
    const substringFrom = code.indexOf('{') + 1;
    const substringTo = code.lastIndexOf('}');
    const blob = new Blob([code.substring(substringFrom, substringTo)], {
      type: 'application/javascript',
    });
    return new Worker(URL.createObjectURL(blob));
  };

  const setIntervalWebWorker = (callback, timerInterval) => {
    worker = getWorker();
    worker.addEventListener('message', (event) => {
      const request = event.data;

      switch (request) {
        case constants.TICK:
          callback();
          break;
      }
    });

    worker.postMessage({
      messageType: constants.SET_INTERVAL,
      intervalMilliseconds: timerInterval,
    });
  };

  const clearIntervalWebWorker = () => {
    worker.postMessage({
      messageType: constants.CLEAR_INTERVAL,
    });
    worker = null;
  };

  return [setIntervalWebWorker, clearIntervalWebWorker];
}
